import { render, staticRenderFns } from "./PresetSwitcher.vue?vue&type=template&id=311c2610&scoped=true&"
import script from "./PresetSwitcher.vue?vue&type=script&lang=js&"
export * from "./PresetSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PresetSwitcher.vue?vue&type=style&index=0&id=311c2610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c2610",
  null
  
)

export default component.exports